import type { TElement } from 'platejs';
import { Plate, PlateContent, usePlateEditor } from 'platejs/react';

import { imagePlugin } from './plugins';
import { usePlugins } from './usePlugins';

export const RichText = <
  TMentionComponentValue extends { type: string },
  TMentionComponentPropsExtension,
>({
  value,
  includeImages,
  includeImageDownloadLink,
  MentionLabel,
  mentionProps,
  i18n,
  ...props
}: {
  value: TElement[];
  includeImages?: boolean;
  includeImageDownloadLink?: boolean;
  MentionLabel?: React.FunctionComponent<
    { value: TMentionComponentValue } & TMentionComponentPropsExtension
  >;
  mentionProps?: TMentionComponentPropsExtension;
  i18n?: {
    captionPlaceholder?: string;
    gdprTooltip?: string;
    dropzoneDescription?: string;
    imageUploadHeading?: string;
    dragDescription?: string;
    uploadButtonText?: string;
    resetButtonText?: string;
    uploadErrorHeading?: string;
    uploadErrorDescription?: string;
  };
}) => {
  const { plugins, components } = usePlugins({
    includeAdvancedFormatting: true,
    MentionLabel,
    mentionProps,
  });

  const editor = usePlateEditor({
    id: JSON.stringify(value),
    plugins,
    override: {
      components,
      plugins: {
        [imagePlugin.key]: {
          options: { includeImages, includeImageDownloadLink, i18n },
        },
      },
    },
    value,
    nodeId: false,
  });

  return (
    <Plate editor={editor} readOnly>
      <PlateContent {...props} />
    </Plate>
  );
};
